export default "__VITE_ASSET__321d8a11__"